import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotificationDto } from '../../../api';
import { NotificationsFacade } from '../../../core/services/notifications.facade';
import { ENTITY_ROUTES } from '../../constants/entity-routes';

/** Task 10.2: header bell with unread badge and a dropdown panel over the own-inbox facade. */
@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [
    MatIconModule,
    MatIconButton,
    MatButton,
    MatBadgeModule,
    MatMenuModule,
    MatTooltipModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app-notification-bell.component.html',
})
export class AppNotificationBellComponent implements OnInit, OnDestroy {
  readonly facade = inject(NotificationsFacade);
  private readonly router = inject(Router);

  private pollHandle: ReturnType<typeof setInterval> | undefined;

  ngOnInit(): void {
    this.facade.refresh();
    // Polling, not a push channel — a light refresh cadence is enough for an own-inbox badge.
    this.pollHandle = setInterval(() => this.facade.refresh(), 60_000);
  }

  ngOnDestroy(): void {
    if (this.pollHandle !== undefined) {
      clearInterval(this.pollHandle);
    }
  }

  onOpen(): void {
    this.facade.refresh();
  }

  markAllRead(): void {
    this.facade.markAllRead();
  }

  open(notification: NotificationDto): void {
    if (!notification.isRead) {
      this.facade.markRead(notification.id);
    }

    const basePath = notification.entityType ? ENTITY_ROUTES[notification.entityType] : undefined;
    if (basePath && notification.entityId) {
      void this.router.navigate([basePath, notification.entityId]);
    }
  }
}
